export default "__VITE_ASSET__7a$ykgk3__"